export const SAVE_PONDER_BY_SESSION = 'SAVE_PONDER_BY_SESSION';

export const savePonder = (sessionId, ponder) => ({
  type: SAVE_PONDER_BY_SESSION,
  payload: {
    sessionId,
    ponder,
  },
});
